<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <v-app>
        <v-content>
          <v-container>
          
          <v-card>
            <v-flex xs6 pa-4>
            <v-alert
              value="message" v-if="message"
              type="success"
              outline
            > <span> {{ message }} </span>
            </v-alert>

             <v-alert
              value="error" v-if="error"
              type="warning"
              outline
            > <span> {{ error }} </span>
            </v-alert>

            <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field 
              name="name" 
              label="Name" 
              v-model="merchant.name"
              :rules="merchantNameRules" 
              required>
            </v-text-field>

            <v-text-field
             name="merchantId" 
             label="Merchant Id" 
             v-model="merchant.merchantId"
             :rules="merchantIdRules" 
             required
             >
            </v-text-field>

            <v-text-field
             name="comment" 
             label="Comment" 
             v-model="merchant.makerComment"
             :rules="commentRules" 
             required
             >
            </v-text-field>

            <v-select
              :items="templates"
              label="Template"
              v-model="merchant.templateId"
              solo
              item-text="name"
              item-value="id"
              :rules="templateRules" 
              required
              autocomplete
            >
            </v-select>

            <v-card-actions>
              <v-btn @click="createMerchant" color="primary">Create Merchant</v-btn>
            </v-card-actions>
            </v-form>
            </v-flex>
             
          </v-card>
        
        </v-container>
        </v-content>
      </v-app>
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'

export default {
  name: 'createmerchant',
  data: function() {
    return {
      merchant: {
        'name': '',
        'merchantId': '',
        'makerComment': ''
      },
      valid: true,
      merchantNameRules: [
        v => !!v || 'Merchant Name is required'
      ],
      merchantIdRules: [
        v => !!v || 'Merchant Id is required'
      ],
      commentRules: [
        v => !!v || 'Comment is required'
      ],
      templateRules: [
        v => !!v || 'Template is required'
      ],
      message: '',
      error: '',
      templates: []
    }
  },
  mounted () {
    this.getTemplates()
  },
  methods: {
    createMerchant() {
      this.message = ''
      this.error = ''
      if (this.$refs.form.validate()) {
        var url = config.serverURI + '/merchant/create'
        var token = store.state.token
        axios.post(url, this.merchant, {
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            console.log('API Response:', response)

            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            if (response.data.error !== false) {
              this.error = response.data.message
              console.log('Error is ' + this.error)
              return
            }
            this.resetMerchantObject()
            this.message = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized' || error.response.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      }
    },
    resetMerchantObject() {
      this.merchant.name = ' '
      this.merchant.merchantId = ' '
      this.merchant.makerComment = ' '
      this.merchant.templateId = ''
    },
    getTemplates () {
      var url = config.serverURI + '/merchant/templates'
      var token = store.state.token
      axios.get(url, {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            if (response.status !== 200) {
              this.error = response.statusText
              console.log('Error is ' + this.error)
              return
            }
            this.templates = response.data
          })
          .catch(error => {
            console.log('error', error.response)
            var data = error.response
            console.log(data)
            if (data.status === 401) {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
    }
  }
}

</script>
<style>
.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// createmerchant.vue?467f57f8